import {AfterViewInit, Component, Input, signal, WritableSignal, contentChildren, ChangeDetectionStrategy} from '@angular/core';
import {SelectOptionComponent} from 'src/app/modules/design-system/multi-select/select-option/select-option.component';
import {MatCheckbox} from '@angular/material/checkbox';

@Component({
  selector: 'app-select-option-group',
  templateUrl: './select-option-group.component.html',
  styleUrls: ['../multi-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatCheckbox]
})
export class SelectOptionGroupComponent implements AfterViewInit {

  @Input() label: string;
  @Input() disabled = false;

  private _noOptionPrefix: boolean
  @Input()
  get noOptionPrefix() {
    return this._noOptionPrefix;
  }
  set noOptionPrefix(value: any) {
    this._noOptionPrefix = value != null && `${value}` !== 'false';
  }

  readonly selectOptions = contentChildren(SelectOptionComponent);

  multiple: WritableSignal<boolean> = signal(false);

  ngAfterViewInit() {
    this.selectOptions().forEach((option: SelectOptionComponent) => {
      option.disabled = option.disabled || this.disabled;
      option.prefix.set(!this.noOptionPrefix);
    });
    const selectOptions = this.selectOptions();
    this.disabled = this.disabled || selectOptions.length === 0 || selectOptions.every((option: SelectOptionComponent) => option.disabled);
  }

  get selected(): boolean {
    return this.selectOptions().length > 0
      && this.selectOptions()
        .filter((option: SelectOptionComponent) => !option.disabled)
        .every((option: SelectOptionComponent) => option.selected());
  }

  get indeterminate(): boolean {
    return this.selectOptions().length > 0
      && !this.selectOptions()
        .filter((option: SelectOptionComponent) => !option.disabled)
        .every((option: SelectOptionComponent) => option.selected())
      && this.selectOptions()
        .filter((option: SelectOptionComponent) => !option.disabled)
        .some((option: SelectOptionComponent) => option.selected());
  }

  onSelect(): void {
    const selected: boolean = this.selected;
    this.selectOptions()
      .filter((option: SelectOptionComponent) => option.selected() === selected && !option.disabled)
      .forEach((option: SelectOptionComponent) => option.onSelect());
  }
}
